import { Screen } from '@/src/components/Screen';
import { GarageVehicleForm } from '@/src/features/garage/GarageVehicleForm';

export default function CreateGarageVehicleScreen() {
  return (
    <Screen>
      <GarageVehicleForm />
    </Screen>
  );
}
